import { store } from '..';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { notifications } from '@mantine/notifications';

import { AuthorizationRoutes, federation } from '@/constant/api';

import { AutorizationResponseType } from '@/types/authorization';

import {
	buildSSOSession,
	createKeycloakClient,
	getAuthProvider,
	isKeycloakConfigured,
} from '@/shared/helpers/keycloak';

import { resetAuth } from '@/utils/resetAuth';

import { setUser } from '../user-process/user-process';

// Пока шло продление, сессию мог сбросить resetAuth: запись вернула бы в очищенное
// хранилище сессию без профиля и пропусков
const isSessionReset = () => !store.getState().user.user;

export const checkAuthAction = createAsyncThunk('user/checkAuth', async () => {
	try {
		const currentUser = store.getState().user.user;

		if (!currentUser) {
			return;
		}

		if (getAuthProvider() === 'sso') {
			if (!isKeycloakConfigured()) {
				throw new Error('Не заполнена конфигурация Keycloak');
			}

			const keycloak = createKeycloakClient();
			const isAuthenticated = await keycloak.init({
				onLoad: 'check-sso',
				pkceMethod: 'S256',
				checkLoginIframe: false,
			});

			if (!isAuthenticated || !keycloak.token) {
				throw new Error('SSO-сессия неактивна');
			}

			await keycloak.updateToken(30);
			if (!keycloak.token) {
				throw new Error('Токен Keycloak отсутствует после обновления');
			}

			if (isSessionReset()) {
				return;
			}

			const user = buildSSOSession(currentUser, keycloak.token, keycloak.tokenParsed?.exp);

			store.dispatch(setUser(user));
			localStorage.setItem('user', JSON.stringify(user));

			return;
		}

		const token = currentUser.update_token;

		if (!token) {
			return;
		}
		if (!federation) {
			return;
		}
		const response = await fetch(`${federation}${AuthorizationRoutes.Session}`, {
			method: 'PUT',
			headers: { 'X-Auth-Token': `Bearer ${token}` },
		});

		const user = (await response.json()) as AutorizationResponseType;

		if (isSessionReset()) {
			return;
		}

		store.dispatch(setUser(user));

		localStorage.setItem('user', JSON.stringify(user));
	} catch (error) {
		resetAuth();
		notifications.show({
			message: 'Не удалось продлить сессию. Выполните вход в систему.',
			bg: '#ff0000',
			mah: '100%',
			maw: 'fit-content',
			mx: 'auto',
			radius: 12,
			autoClose: 5000,
			withCloseButton: false,
		});
	}
});
